// extracted by mini-css-extract-plugin
export var wordContainer = "_ly-0";